import { render, staticRenderFns } from "./Explain.vue?vue&type=template&id=2c274e0f&scoped=true"
import script from "./Explain.vue?vue&type=script&lang=js"
export * from "./Explain.vue?vue&type=script&lang=js"
import style0 from "./Explain.vue?vue&type=style&index=0&id=2c274e0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c274e0f",
  null
  
)

export default component.exports